import { View, Text as PDFText } from '@react-pdf/renderer'

import styles from './styles/index.styles'

const Title = () => {
  return (
    <View style={styles.title}>
      <PDFText style={styles.headerTitle}>Booking Confirmation</PDFText>
    </View>
  )
}
export default Title
